import { loadStripe } from '@stripe/stripe-js'

let stripe
let elements
let cardSingleton

export async function ensureStripe() {
  const pk = import.meta.env.VITE_STRIPE_PUBLIC_KEY
  if (!pk) throw new Error('Falta VITE_STRIPE_PUBLIC_KEY')
  if (!stripe) stripe = await loadStripe(pk)
  if (!stripe) throw new Error('Stripe no pudo inicializarse')
  if (!elements) elements = stripe.elements()
  return { stripe, elements }
}

export async function createPaymentIntent(amountCents, metadata = {}) {
  // En desarrollo, usa vite.config.js (localhost)
  // En producción web, usa el servicio backend de Stripe
  // En Tauri, usa el origen actual
  const isDev = import.meta.env.DEV;
  const stripeApiUrl = import.meta.env.VITE_STRIPE_API_URL;

  // Prioridad: 1) Variable de entorno, 2) Servicio backend en producción, 3) Origen actual
  let baseUrl = stripeApiUrl;
  if (!baseUrl) {
    if (!isDev) {
      // En producción, usar el servicio backend
      baseUrl = 'https://eltranquero.com/stripe-api';
    } else {
      // En desarrollo, usar el servidor local
      baseUrl = `${window.location.protocol}//${window.location.host}`;
    }
  }

  const url = `${baseUrl}/create-payment-intent`;
  const amt = Math.max(1, Number(amountCents || 0));

  console.log('[Stripe] Creando PaymentIntent:', { url, amount: amt });

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ amount: amt, currency: 'mxn', metadata }),
    });

    const text = await res.text();
    const json = (() => {
      try {
        return JSON.parse(text);
      } catch (e) {
        console.error('[Stripe] Error parseando respuesta:', text);
        return { error: text || 'Error desconocido' };
      }
    })();

    if (!res.ok) {
      console.error('[Stripe] Error HTTP:', res.status, json);
      throw new Error(json?.error || `Error ${res.status}: No se pudo crear PaymentIntent`);
    }

    const clientSecret = json?.client_secret || json?.clientSecret;
    if (!clientSecret) {
      console.error('[Stripe] Falta client_secret en respuesta:', json);
      throw new Error('Falta client_secret del PaymentIntent');
    }

    console.log('[Stripe] PaymentIntent creado exitosamente');
    return clientSecret;
  } catch (err) {
    console.error('[Stripe] Error creando PaymentIntent:', err);
    throw err;
  }
}

export function mountCardElement(container, darkMode = false) {
  if (!elements) throw new Error('Stripe Elements no está listo')

  const textColor = darkMode ? '#e2e8f0' : '#32325d';
  const placeholderColor = darkMode ? '#94a3b8' : '#aab7c4';
  const iconColor = darkMode ? '#e2e8f0' : '#32325d';

  const style = {
    base: {
      fontSize: '16px',
      color: textColor,
      '::placeholder': {
        color: placeholderColor,
      },
      iconColor: iconColor
    },
  }

  if (!cardSingleton) {
    cardSingleton = elements.create('card', { style })
  } else {
    cardSingleton.update({ style })
  }

  try { cardSingleton.unmount() } catch { }
  cardSingleton.mount(container)
  return cardSingleton
}

export function unmountCardElement(container) {
  try {
    if (cardSingleton) cardSingleton.unmount()
    if (container && container.__card) delete container.__card
  } catch { }
}

export async function confirmCard({ clientSecret, card, billingDetails = {} }) {
  if (!stripe) throw new Error('Stripe no está listo')

  const paymentMethodData = {
    card
  };

  // Agregar billing details si están disponibles
  if (billingDetails && Object.keys(billingDetails).length > 0) {
    paymentMethodData.billing_details = billingDetails;
  }

  const result = await stripe.confirmCardPayment(clientSecret, {
    payment_method: paymentMethodData,
  })

  if (result.error) throw new Error(result.error.message || 'Error de pago')
  const status = result?.paymentIntent?.status
  if (status !== 'succeeded') throw new Error('Pago no confirmado')
  return result
}

export async function refundPayment(paymentIntentId, chargeId, amount) {
  // En desarrollo, usa vite.config.js (localhost)
  // En producción web, usa el servicio backend de Stripe
  // En Tauri, usa el origen actual
  const isDev = import.meta.env.DEV;
  const stripeApiUrl = import.meta.env.VITE_STRIPE_API_URL;

  // Prioridad: 1) Variable de entorno, 2) Servicio backend en producción, 3) Origen actual
  let baseUrl = stripeApiUrl;
  if (!baseUrl) {
    if (!isDev) {
      // En producción, usar el servicio backend
      baseUrl = 'https://eltranquero.com/stripe-api';
    } else {
      // En desarrollo, usar el servidor local
      baseUrl = `${window.location.protocol}//${window.location.host}`;
    }
  }

  const url = `${baseUrl}/refund-payment`;
  const body = {};
  if (paymentIntentId) body.payment_intent_id = paymentIntentId;
  if (chargeId) body.charge_id = chargeId;
  if (amount && Number(amount) > 0) body.amount = Number(amount);

  console.log('[Stripe] Creando reembolso:', { url, body });

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });

    const text = await res.text();
    const json = (() => {
      try {
        return JSON.parse(text);
      } catch (e) {
        console.error('[Stripe] Error parseando respuesta:', text);
        return { error: text || 'Error desconocido' };
      }
    })();

    if (!res.ok) {
      console.error('[Stripe] Error HTTP:', res.status, json);
      throw new Error(json?.error || `Error ${res.status}: No se pudo crear el reembolso`);
    }

    console.log('[Stripe] Reembolso creado exitosamente:', json);
    return json;
  } catch (err) {
    console.error('[Stripe] Error creando reembolso:', err);
    throw err;
  }
}